import React from 'react'

interface IcDeleteProps extends React.SVGProps<SVGSVGElement> {
  color?: string
  style?: React.CSSProperties
}

const IcDelete: React.FC<IcDeleteProps> = ({ color = '#6b7280', style, ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0, ...style }}
      {...props}
    >
      <path
        d="M2.08 5.382H13.6M6.56 7.878V11.718M9.12 7.878V11.718M9.76 14.342H5.92C4.512 14.342 3.36 13.19 3.36 11.782V5.382H12.32V11.782C12.32 13.19 11.168 14.342 9.76 14.342ZM9.76 5.382H5.92V4.038C5.92 3.334 6.496 2.758 7.2 2.758H8.48C9.184 2.758 9.76 3.334 9.76 4.038V5.382Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IcDelete
